import { useRef, useEffect } from 'react';

/**
 * React Hook used to observer HTML element layout
 * @param onChange callback to run when the element is changed
 * @returns
 */
const useHTMLElementObserver = ({ onChange, }) => {
    const contentRef = useRef(null);
    const resizingDelayTimer = useRef();
    useEffect(() => {
        let resizedObserver;
        if (contentRef.current) {
            resizedObserver = new ResizeObserver(() => {
                clearTimeout(resizingDelayTimer === null || resizingDelayTimer === void 0 ? void 0 : resizingDelayTimer.current);
                resizingDelayTimer.current = setTimeout(() => {
                    if (contentRef.current)
                        onChange(contentRef.current);
                });
            });
            resizedObserver === null || resizedObserver === void 0 ? void 0 : resizedObserver.observe(contentRef.current);
        }
        return () => {
            if (resizedObserver && contentRef.current) {
                resizedObserver === null || resizedObserver === void 0 ? void 0 : resizedObserver.unobserve(contentRef.current);
                resizedObserver === null || resizedObserver === void 0 ? void 0 : resizedObserver.disconnect();
            }
        };
    }, [contentRef.current]);
    return {
        contentRef,
    };
};

export { useHTMLElementObserver };
